import storeModule from '../../store-module'
import { defineStore } from 'pinia'

export default defineStore(
  'real-estate-developments-unit-block',
  storeModule.createStoreModule('real-estate-developments-unit-block')
)
